import styled from 'styled-components';
import { colors } from 'globalStyles';

export const DraggableContainer = styled.div`
  ul {
    padding: 0;
    margin: 0;
    ${({ dataCount }) =>
    dataCount &&
    `
      height: ${47 * dataCount}px;
    `
  }
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 47px;
      border: 1px solid ${colors.LIGHT_GRAY};
      border-bottom: 0;
      padding: 18px;
      cursor: move;
      cursor: -webkit-grab;
      cursor: -moz-grab;
      overflow: hidden;

      &:active {
        cursor: move;
        cursor: -webkit-grabbing;
        cursor: -moz-grabbing;
      }

      .left {
        display: flex;
        align-items: center;
        padding-left: 20px;
        position: relative;

        .select-action {
          display: flex;
          align-items: center;
          background: none;
          border: none;
          padding: 0;
          font: inherit;
          color: inherit;
          cursor: pointer;
          text-align: left;
        }

        &:before {
          content: '.';
          position: absolute;
          left: 0;
          top: -8px;
          font-size: 12px;
          line-height: 20px;
          color: ${colors.DARK};
          text-shadow: 0 5px ${colors.DARK}, 0 10px ${colors.DARK}, 5px 0 ${colors.DARK}, 5px 5px ${colors.DARK}, 5px 10px ${colors.DARK};
        }

        .value {
          padding-left: 10px;
          font-size: 14px;
          color: #131B38;
          font-weight: 400;
          max-width: 340px;
          width: 100%;
          margin-left: 5px;
          white-space: nowrap;
          direction: rtl;
          overflow: hidden;
        }
      }
    }

    li:nth-child(1) {
      border-radius: 3px 3px 0 0;
    }

    .right-action {
      cursor: pointer;
      z-index: 1;
      background: none;
      border: none;
      padding: 0;
      color: inherit;
    }
  }
`;